<template>
  <div class="page-main">
    <el-button v-if="isAdmin" class="m-b-10" type="success" size="mini" @click="itemDo()">
      新增模板
    </el-button>
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      v-bind="tableOptions"
      :height="$util.getViewHeight() - 148 + (isAdmin ? 0 : 38)"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_create_date="{ row }">
        {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
      </template>
      <template #default_operate="{ row }">
        <template v-if="isAdmin">
          <el-link type="primary" @click="itemDo(row)">编辑</el-link>
          <el-link
            v-if="itemIsShowDelete(row.lei_mu_lei_xing)"
            type="danger"
            @click="itemDelete(row)"
            >删除</el-link
          >
        </template>
        <template v-if="!isAdmin">
          <el-link
            v-if="row.lei_mu_lei_xing === '原料' || row.lei_mu_lei_xing === '加工'"
            type="success"
            @click="itemSetPrice(row)"
            >设置价格</el-link
          >
        </template>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改模板 -->
    <PopupDoMuBan
      v-if="isShowPopupDoMuBan"
      :show.sync="isShowPopupDoMuBan"
      :detailId="detailId"
      @success="searchListData"
    />

    <!-- 弹窗-设置价格 -->
    <PopupSetPrice
      v-if="isShowPopupSetPrice"
      :show.sync="isShowPopupSetPrice"
      :list="[detailData]"
      type="价格"
      @success="setPriceSuccess"
    />
  </div>
</template>

<script>
import PopupDoMuBan from './common/popup-do-mu-ban'
import PopupSetPrice from './common/popup-set-price'
export default {
  components: {
    PopupDoMuBan,
    PopupSetPrice
  },
  data() {
    return {
      filterData: {
        id: '',
        category1: '',
        category2: '',
        category3: '',
        category4: '',
        texture: '',
        mu_ban_ming_cheng: '',
        mu_ban_guan_jian_ci: '',
        create_name: '',
        create_date: ''
      },
      detailId: '',
      detailData: null,
      isShowPopupDoMuBan: false,
      isShowPopupSetPrice: false,
      headerFilterUrl: '/admin/gcvip/muBan/searchHeard',
      tableOptions: {
        loading: true,
        size: 'mini',
        border: true,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          {
            fixed: 'left',
            title: '序号',
            type: 'seq',
            width: 40
          },
          { field: 'lei_mu_lei_xing', title: '商品类目类型', slots: { header: 'header_input' } },
          { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
          { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
          { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
          { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
          { field: 'texture', title: '材质', slots: { header: 'header_input' } },
          { field: 'mu_ban_ming_cheng', title: '商品模板名称', slots: { header: 'header_input' } },
          {
            field: 'mu_ban_guan_jian_ci',
            title: '商品模板关键词',
            slots: { header: 'header_input' }
          },
          { field: 'create_name', title: '创建人', slots: { header: 'header_input' } },
          {
            field: 'create_date',
            title: '创建时间',
            slots: { header: 'header_input', default: 'default_create_date' }
          },
          { title: '操作', slots: { default: 'default_operate' } }
        ],
        data: []
      }
    }
  },
  computed: {
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    }
  },
  mounted() {
    this.searchListData()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData: this.filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 项-增改
    itemDo(row) {
      if (row === undefined) {
        this.detailId = ''
      } else {
        this.detailId = row.id
      }
      this.isShowPopupDoMuBan = true
    },
    // 项-设置价格
    itemSetPrice(row) {
      this.detailData = this.$util.deepCopy(row)
      this.isShowPopupSetPrice = true
    },
    // 设置价格-成功
    setPriceSuccess(val) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/saveOrUpdate',
        data: val[0]
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.searchListData()
          this.$message.success('保存成功')
        }
      })
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('该模板和其关联商品将一起删除，您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/muBan/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 项-是否可删除
    itemIsShowDelete(type) {
      let list = ['零件', '组装', '商品']
      let result = list.join(',').includes(type)
      return !result || true
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
